import { conversationsPath } from './config'
import { currentLocale } from '../../../utils/localeHelpers'

function headers (extra = {}) {
  return {
    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content'),
    'X-Requested-With': 'XMLHttpRequest',
    ...extra
  }
}

async function request (path, options = {}) {
  const response = await window.fetch(path, { credentials: 'same-origin', ...options })
  if (!response.ok) throw Object.assign(new Error(`Vera request failed: ${response.status}`), { status: response.status })
  return response
}

function postJSON (path, body) {
  return request(path, {
    method: 'POST',
    headers: headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(body)
  })
}

// The conversations index also serves the shopper's page as HTML.
async function readJSON (path) {
  const response = await request(path, { headers: { Accept: 'application/json' } })
  return response.json()
}

// Throttled per IP (Rack::Attack).
export function isRateLimited (error) {
  return error?.status === 429
}

export function listConversations () {
  return readJSON(conversationsPath())
}

export function listWishlistItems () {
  return readJSON('/api/v1/wishlist_items')
}

export async function createConversation () {
  // VERA's routes carry no locale: the turn's links and copy follow the page's.
  const response = await postJSON(conversationsPath(), { locale: currentLocale() })
  return response.json()
}

export function closeConversation (id) {
  return request(`${conversationsPath()}/${id}`, {
    method: 'DELETE',
    headers: headers()
  })
}

export function sendMessage (id, text, attachmentIds, retry = false) {
  return postJSON(`${conversationsPath()}/${id}/messages`, { text, attachment_ids: attachmentIds, retry, locale: currentLocale() })
}

export function interrupt (id) {
  return postJSON(`${conversationsPath()}/${id}/interrupt`, {})
}

export function sendListingFeedback (id, payload) {
  return postJSON(`${conversationsPath()}/${id}/listing_feedbacks`, payload)
}

export function sendReplyFeedback (id, payload) {
  return postJSON(`${conversationsPath()}/${id}/reply_feedbacks`, payload)
}

export function fetchEvents (id, afterSeq) {
  return readJSON(`${conversationsPath()}/${id}/events?after_seq=${afterSeq}`)
}

export async function uploadAttachment (id, file) {
  const body = new window.FormData()
  body.append('image', file)

  const response = await request(`${conversationsPath()}/${id}/uploads`, {
    method: 'POST',
    headers: headers(),
    body
  })
  const payload = await response.json()
  return payload.attachment
}

export function removeAttachment (id, attachmentId) {
  return request(`${conversationsPath()}/${id}/uploads/${attachmentId}`, {
    method: 'DELETE',
    headers: headers()
  })
}
